import { render, staticRenderFns } from "./ProductVariations.vue?vue&type=template&id=85bca6ca&"
import script from "./ProductVariations.vue?vue&type=script&lang=js&"
export * from "./ProductVariations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports